import { CONTENT_TYPES } from '@core/constants/contentTypes.constants';
import { CleanedContentfulAsset } from '@core/types/contentful.types';
import { Asset } from '@graphql/index';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';

export const assetTransform = (
  asset: CleanContentful<Asset>
): Omit<CleanedContentfulAsset, 'focus'> => ({
  ...asset,
  __typename: CONTENT_TYPES.ASSET_TAG,
  id: asset.id || 'id',
  alt: asset.description || asset.title || '',
  fit: 'fill',
  width: asset.width || 0,
  height: asset.height || 0,
  url: asset.url || '',
});
